<template>
    <div>
        <hero image="https://api.ratoab.se/HeroImages?location=0"
              :dark-background="false"
              style="height: 60vh"
        />

        <about-commercial class="mt-5"/>
    </div>
</template>

<script>
    import Hero from "../../components/Hero";
    import AboutCommercial from "../../components/Services/AboutCommercial";
    export default {
        name: "Commercial",
        components: {AboutCommercial, Hero},
        mounted () {
            window.scrollTo(0, 0)
        }
    }
</script>

<style scoped>

</style>
